'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.secondsFromNow;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/secondsFromNow.js
// module id = 588
// module chunks = 0